
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 12 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 11.367A5.36 5.36 0 012.21 2.21a5.36 5.36 0 117.581 7.581A5.328 5.328 0 016 11.367zm0-9.983A4.618 4.618 0 1010.618 6 4.623 4.623 0 006 1.384z","fill":"#ef5350"}}),_c('g',{attrs:{"data-name":"Group 687","opacity":".4","fill":"#ef5350"}},[_c('path',{attrs:{"data-name":"Vector","d":"M7.165 7.702L4.298 4.834a.38.38 0 01.537-.537l2.868 2.867a.38.38 0 11-.538.538z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M4.297 7.702a.38.38 0 010-.538l2.868-2.867a.38.38 0 01.537.537L4.835 7.702a.38.38 0 01-.538 0z"}})])])
          )
        }
      }
    